/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer">;
    readonly " $refType": "SbSharedRelatedItems_viewer";
};
export type SbSharedRelatedItems_viewer$data = SbSharedRelatedItems_viewer;
export type SbSharedRelatedItems_viewer$key = {
    readonly " $data"?: SbSharedRelatedItems_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedItems_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRelatedItems_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '6e338f56cc8b0d082a9998c9f7ba42b7';
export default node;
